import { ALT, Dialog, MOD } from "./ui.js";

const GROUPS: { title: string; rows: [string, string][] }[] = [
  {
    title: "Moving and selecting",
    rows: [
      ["Arrows", "Move"],
      ["Shift + Arrows, Shift-click, drag", "Extend the selection"],
      [`${MOD}Arrows`, "Go to the edge"],
      [`${MOD}Shift + Arrows`, "Extend to the edge"],
      ["Home, End", "Start or end of the row"],
      [`${MOD}Home, ${MOD}End`, "First or last cell"],
      ["Ctrl+Space", "Select the column"],
      ["Shift+Space", "Select the row"],
      [`${MOD}A`, "Select everything"],
      ["Tab, Shift+Tab", "Right, left; leave the grid at its edge"],
      ["Escape", "Collapse the selection"],
    ],
  },
  {
    title: "Editing a cell",
    rows: [
      ["Enter, F2, or start typing", "Edit (typing adds a session, never replaces)"],
      ["Enter", "Add the highlighted suggestion; on an empty line, save and move down"],
      ["Comma", "Add what is typed"],
      ["Tab", "Save and move right"],
      [`${MOD}Enter`, "Save into every selected cell"],
      ["Escape", "Close suggestions, then cancel"],
      ["Backspace twice", "Select, then remove the last session"],
      ["Left Arrow at the start", "Walk onto the sessions; Delete removes one"],
      [`${ALT}Left, ${ALT}Right`, "Move the selected session"],
      ["Enter on a session, or double-click", "Edit it"],
    ],
  },
  {
    title: "Sessions in a cell",
    rows: [
      ["Drag a chip", "Reorder it in its cell, or move it to another cell"],
      [`${ALT}drag a chip`, "Copy it to another cell"],
      ["Right-click a chip, or Shift+F10 on a cell", "Move earlier, move later, open, remove"],
      ["Double-click a chip", "Open its definition side by side"],
    ],
  },
  {
    title: "Many cells",
    rows: [
      [`${MOD}C, ${MOD}X, ${MOD}V`, "Copy, cut, paste (works with Sheets and Excel)"],
      [`${MOD}D`, "Fill down"],
      [`${MOD}R`, "Fill right"],
      ["Delete, Backspace", "Clear the selection"],
      [`${MOD}Z, ${MOD}Shift+Z`, "Undo, redo"],
    ],
  },
  {
    title: "A definition",
    rows: [
      [`${MOD}Return`, "Details for the caret's line"],
      [`${MOD}.`, "The next line to look at"],
      [`${MOD}J`, "Ask the assistant"],
      [`${MOD}/`, "The guide"],
      ["Tab, Shift+Tab", "Indent, outdent the line"],
    ],
  },
  {
    title: "Columns and days",
    rows: [
      ["Enter or Shift+F10 on a heading", "Column options"],
      [`${MOD}${ALT}Left, ${MOD}${ALT}Right`, "Move the column"],
      ["Left Arrow from the first column", "The day's location; Enter edits it"],
      ["Space", "Show the cell's definitions"],
      ["?", "This list"],
    ],
  },
];

export function ShortcutSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} title="Keyboard shortcuts" wide>
      <div className="bp-shortcuts">
        {GROUPS.map((g) => (
          <table key={g.title} className="bp-shortcut-table">
            <caption>{g.title}</caption>
            <tbody>
              {g.rows.map(([keys, what]) => (
                <tr key={keys}>
                  <th scope="row">
                    <kbd>{keys}</kbd>
                  </th>
                  <td>{what}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </div>
    </Dialog>
  );
}
